// Training listing data - separated to avoid babel plugin issues
export const trainings = [
  {
    id: 9,
    title: 'HackTheWeb: Pentesting Beyond Basics',
    description: 'Instructor-led advanced web penetration testing course with hands-on labs covering modern web application security vulnerabilities beyond the fundamentals.',
    eventName: 'Byt3con January 2026',
    date: 'Jan 22-24, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Dhruv Shah',
        bio: 'Founder of BYT3CON. Cybersecurity expert with extensive offensive security experience.',
        photo: '/images/trainers/DhruvShah.webp',
        designation: 'Founder',
        company: 'TCP Infosec',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    // seats: 25,
    // seatsLeft: 0,
    price: '$1,299',
    tags: ['Penetration Testing', 'Web Security'],
    featured: false,
    popular: false,
    status: 'archived',
  },
  {
    id: 10,
    title: 'Threat Hunting Using Memory Forensics & Endpoint Telemetry',
    description: 'Instructor-led advanced threat hunting course with hands-on labs using memory forensics and endpoint telemetry data to detect sophisticated threats.',
    eventName: 'Byt3con January 2026',
    date: 'Jan 22-24, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Monnappa K A',
        bio: 'Founders of Cysinfo. Expert in threat hunting, forensics, and endpoint security.',
        photo: '/images/trainers/MonnappaKA.webp',
      },
      {
        name: 'Sajan Shetty',
        bio: 'Founders of Cysinfo. Expert in threat hunting, forensics, and endpoint security.',
        photo: '/images/trainers/SajanShetty.webp',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    // seats: 25,
    // seatsLeft: 0,
    price: '$1,399',
    tags: ['Threat Hunting', 'Forensics', 'Endpoint Security'],
    featured: false,
    popular: false,
    status: 'archived',
  },
  {
    id: 11,
    title: 'Kubernetes Crusade: Deep Dive into Attacks, Defense & Mitigations',
    description: 'Instructor-led comprehensive training with hands-on labs on Kubernetes security covering attacks, defense strategies, and mitigations.',
    eventName: 'Byt3con January 2026',
    date: 'Jan 22-24, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Anjali Shukla',
        bio: 'Cloud security expert from Flipkart with extensive Kubernetes experience.',
        photo: '/images/trainers/AnjaliShukla.webp',
      },
      {
        name: 'Divyanshu Shukla',
        bio: 'Cloud security expert from Confluent with extensive Kubernetes experience.',
        photo: '/images/trainers/DivyanshuShukla.webp',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    // seats: 25,
    // seatsLeft: 0,
    price: '$1,499',
    tags: ['Container Security', 'Kubernetes', 'Cloud Security'],
    featured: false,
    popular: false,
    status: 'archived',
  },
  {
    id: 12,
    title: 'Red Teaming in Active Directory & Entra ID',
    description: 'Instructor-led expert-level training with hands-on labs to master red teaming techniques targeting Active Directory and Azure Entra ID infrastructure.',
    eventName: 'Byt3con January 2026',
    date: 'Jan 22-24, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Yash Bharadwaj',
        bio: 'Red team operator from CyberWarFare Labs. Expert in identity and access security.',
        photo: '/images/trainers/YashBharadwaj.webp',
      },
      {
        name: 'Manish Gupta',
        bio: 'Red team operator from CyberWarFare Labs. Expert in identity and access security.',
        photo: '/images/trainers/ManishGupta.webp',
      },
    ],
    level: 'Expert',
    venue: 'Online Virtual',
    // seats: 25,
    // seatsLeft: 0,
    price: '$1,599',
    tags: ['Red Teaming', 'Active Directory', 'Identity Security'],
    featured: false,
    popular: false,
    status: 'archived',
  },
  {
    id: 13,
    title: 'HACK THE CLOUD – Exploiting AWS and Google Cloud for Fun and Profit',
    description: 'Instructor-led training with hands-on labs to exploit misconfigurations and vulnerabilities in AWS and Google Cloud environments.',
    eventName: 'Byt3con January 2026',
    date: 'Jan 22-24, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Anant Shrivastava',
        bio: 'Founder of Cyfinoid Research. Expert in cloud security and exploitation techniques.',
        photo: '/images/trainers/AnantShrivastava.webp',
        designation: 'Founder',
        company: 'Cyfinoid',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    // seats: 25,
    // seatsLeft: 0,
    price: '$1,499',
    tags: ['Cloud Security', 'AWS', 'Google Cloud'],
    featured: false,
    popular: false,
    status: 'archived',
  },
  {
    id: 14,
    title: 'Attack and Defend Software Supply Chains',
    description: 'Instructor-led training with hands-on labs covering offensive and defensive techniques for securing software supply chains against modern threats.',
    eventName: 'Byt3con January 2026',
    date: 'Jan 22-24, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Anant Shrivastava',
        bio: 'Founder of Cyfinoid Research. Expert in supply chain security and DevSecOps.',
        photo: '/images/trainers/AnantShrivastava.png',
        designation: 'Founder',
        company: 'Cyfinoid',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    // seats: 25,
    // seatsLeft: 0,
    price: '$1,399',
    tags: ['Supply Chain Security', 'DevSecOps'],
    featured: false,
    popular: false,
    status: 'archived',
  },
  {
    id: 15,
    title: 'HackTheWeb: Pentesting Beyond Basics',
    description: 'Master intermediate-level web application penetration testing with hands-on labs following OWASP Testing Guide methodology. Learn advanced exploitation techniques, API security testing, authentication bypasses, and business logic vulnerabilities. Includes OVA lab environment, comprehensive materials, and 5 days of extended lab access post-training.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 15-17, 2026',
    time: '9:00 AM - 5:30 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Dhruv Shah',
        bio: 'Information security professional with 13+ years of expertise in application, mobile, network, and cloud security. Co-author of "Kali Linux Intrusion and Exploitation" and "Hands-on Pentesting with BurpSuite" by Packtpub. Trainer at major cybersecurity conferences including Black Hat USA, Europe, and Asia, as well as Hack in Paris, BSides Lisbon, and Texas Cyber Summit. Provided security training to clients across the UK, EU, and USA. Core member of Recon Village at Defcon. Online presence: @snypter.',
        photo: '/images/trainers/DhruvShah.webp',
        designation: 'Founder',
        company: 'TCP Infosec',
      },
    ],
    level: 'Intermediate',
    venue: 'Physical',
    // seats: 25,
    // seatsLeft: 0,
    price: '₹37,000',
    tags: ['Pentesting', 'Web Hacking', 'Offensive'],
    featured: true,
    popular: true,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=81417',
  },
  {
    id: 16,
    title: 'Offensive AI: Attacking AI Native Apps, IDE\'s, & Browsers',
    description: 'Hands-on intermediate training equipping security professionals to attack AI systems, models, and native applications. Learn prompt injection, supply chain exploitation, model poisoning, and multi-agent system attacks through real-world exercises.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 15-17, 2026',
    time: '9:00 AM - 5:30 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Anirudh Anand',
        bio: 'Security researcher with primary focus on Web and Mobile Application Security. Head of Product Security at CRED. 12+ years of bug bounty and security tool contributions. CTF competitor with Team bi0s. Presented at DEFCON Las Vegas 2025, OWASP AppSec, Nullcon, BlackHat US 2020, and other major conferences.',
        photo: '/images/trainers/AnirudhAnand.webp',
        designation: 'Head of Security',
      },
      {
        name: 'Hritik Vijay',
        bio: 'Senior Security Engineer at CRED with 7+ years of application security expertise. Maintainer and Google Summer of Code mentor for VulnerableCode. Contributor to Linux Kernel and multiple open source projects. Presented at Linux Foundation Summit, Blackhat EU 23, Nullcon 2025, and Blackhat 2025.',
        photo: '/images/trainers/HritikVijay.webp',
        designation: 'Senior Security Engineer',
      },
    ],
    level: 'Intermediate',
    venue: 'Physical',
    // seats: 25,
    // seatsLeft: 0,
    price: '₹37,000',
    tags: ['AI Security', 'Prompt Injection', 'Red Teaming', 'Offensive'],
    featured: true,
    popular: true,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=92327',
  },
  {
    id: 17,
    title: 'Attack and Defend Software Supply Chains',
    description: 'Comprehensive training covering offensive and defensive strategies for software supply chain security. Learn to identify and exploit vulnerabilities, then implement industry-standard frameworks (SLSA, NIST SSDF) to protect your supply chain through hands-on labs.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 15-17, 2026',
    time: '9:00 AM - 5:30 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Sunil Yadav',
        bio: 'Sunil is the founder and head of cybersecurity at x-biz Techventures with over 13 years of experience. He is a trainer and has delivered web hacking training at BlackHat USA and Europe, as well as OWASP Appsec Europe. He specialises in creating AI-powered computer vision and cybersecurity products, including attack surface monitoring, vulnerability management, and compliance tools. He has experience in creating products such as software composition analysis, v-KYC auditing software, document management systems, and payment systems.',
        photo: '/images/trainers/SunilYadav.jpeg',
        designation: 'Founder/ Head of Security',
        company: 'x-biz Techventures',
      },
      {
        name: 'Anant Shrivastava',
        bio: 'Founder of Cyfinoid Research with expertise in security (offense and defense), development, and operations. Trainer and speaker at Black Hat USA/Asia/EU, Nullcon, c0c0n, and other renowned conferences. Leads open-source projects including Tamer Platform and CodeVigilant. Active contributor to null community, Garage4Hackers, and OWASP.',
        photo: '/images/trainers/AnantShrivastava.webp',
        designation: 'Founder',
        company: 'Cyfinoid',
      },
    ],
    level: 'Intermediate',
    venue: 'Physical',
    // seats: 25,
    // seatsLeft: 0,
    price: '₹37,000',
    tags: ['Supply Chain Security', 'DevSecOps', 'Offensive', 'Defensive'],
    featured: true,
    popular: true,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=92689',
  },
  {
    id: 18,
    title: 'HuntCraft: Practical Threat Hunting',
    description: 'Intensive one-day training on practical threat hunting using Sigma, Splunk/SPL, and KQL. Learn to write detection rules, analyze logs, and hunt for threats using industry-standard query languages with pre-configured lab environments.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 18, 2026',
    time: '9:00 AM - 5:30 PM IST',
    duration: '1 Day',
    instructors: [
      {
        name: 'Amey Gat',
        bio: 'Principal Threat Researcher at Fortinet with 20+ years of industry experience. Previously worked as Threat Intelligence Researcher and Information Security consultant. Contributor to open-source projects including HoneyPy, DataSploit, IntelOwl, and Sigma. Speaker at NullCon, AVAR Singapore, Bsides Delhi, and other international security conferences.',
        photo: '/images/trainers/AmeyGat.webp',
        designation: 'Principal Threat Researcher',
        company: 'Fortinet',
      },
    ],
    level: 'Intermediate',
    venue: 'Online Virtual',
    // seats: 25,
    // seatsLeft: 0,
    price: '₹16,000',
    tags: ['Threat Hunting', 'Detection', 'Sigma', 'SIEM'],
    featured: true,
    popular: true,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=92954',
  },
  {
    id: 19,
    title: 'Red Teaming Active Directory & Entra ID',
    description: 'Intensive hands-on training to master red teaming techniques against Active Directory and Azure Entra ID. Learn to exploit misconfigurations, perform lateral movement from on-premise to cloud, and execute full-spectrum adversary simulation in hybrid environments.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 15-17, 2026',
    time: '9:00 AM - 5:30 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Yash Bharadwaj',
        bio: 'Security R&D Director at CyberWarFare Labs with 8.5+ years of expertise in offensive security and threat emulation. Specializes in discovery and operationalization of novel TTPs, red/blue team infrastructure, and multi-cloud/on-premise exploitation. Recognized trainer at Black Hat, DEF CON, c0c0n, Nullcon, X33fcon, NorthSec, and various BSides and OWASP chapters.',
        photo: '/images/trainers/YashBharadwaj.webp',
        designation: 'Security R&D Director',
        company: 'CyberWarFare Labs',
      },
      {
        name: 'Manish Gupta',
        bio: 'CEO at CyberWarFare Labs with 10.5+ years of expertise in offensive information security. Former Red Team Operator and Team Lead at Microsoft, Grab, and Citrix. Specializes in advanced red teaming, complex enterprise environments, on-premise and multi-cloud infrastructures, and APT methodologies. Speaker at Black Hat, DEF CON, c0c0n, Nullcon, BSides, X33fcon Poland, and NorthSec.',
        photo: '/images/trainers/ManishGupta.webp',
        designation: 'CEO',
        company: 'CyberWarFare Labs',
      },
    ],
    level: 'Expert',
    venue: 'Physical',
    // seats: 25,
    // seatsLeft: 0,
    price: '₹37,000',
    tags: ['Red Teaming', 'Active Directory', 'Azure Entra ID', 'Identity Security', 'Penetration Testing', 'Cloud Security'],
    featured: true,
    popular: true,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=92690',
  },
  {
    id: 20,
    title: 'HackTheCloud – Exploiting AWS and GCP for Fun and Profit',
    description: 'This 3-day, hands-on training explores realistic attack paths in AWS and Google Cloud. Students deploy vulnerable labs with Terraform, exploit weaknesses including IAM flaws, metadata abuse, secret exposure, and Kubernetes misconfigurations, and learn how application issues become cloud compromise, lateral movement, and defensible security lessons.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 15-17, 2026',
    time: '9:00 AM - 5:30 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Riyaz Walikar',
        bio: 'Riyaz Walikar is a seasoned security researcher, evangelist and offensive security expert with a wealth of experience across industry verticals and technologies. Riyaz has over 15 years of hands on offensive security experience focussing on Web, API, Mobile, Thick Clients, Systems, Internet facing and unreachable infra, Wireless, Cloud, Container, Kubernetes and more recently AI Agentic and MCP security.\n\nProfessionally, Riyaz has run pentesting and research teams at Microland, PwC, Citrix, Appsecco and Kloudle in the past. He now does full time research and consulting on his own while continuing to mentor and teach at various events and conferences.\n\nWhen he isn\'t breaking things and looking under the hood of systems, Riyaz loves to stargaze, do photograhy, travel, google for easy weight loss solutions and crack really bad jokes to gain more followers.',
        photo: '/images/trainers/RiyazWalikar.jpeg',
      },
      {
        name: 'Anant Shrivastava',
        bio: 'Founder of Cyfinoid Research with expertise in security (offense and defense), development, and operations. Trainer and speaker at Black Hat USA/Asia/EU, Nullcon, c0c0n, and other renowned conferences. Leads open-source projects including Tamer Platform and CodeVigilant. Active contributor to null community, Garage4Hackers, and OWASP.',
        photo: '/images/trainers/AnantShrivastava.webp',
        designation: 'Founder',
        company: 'Cyfinoid',
      },
    ],
    level: 'Intermediate',
    venue: 'Physical',
    // seats: 25,
    // seatsLeft: 0,
    price: '₹37,000',
    tags: ['Cloud Security', 'AWS', 'Google Cloud', 'Exploitation'],
    featured: true,
    popular: true,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=92326',
  },
  {
    id: 21,
    title: 'Applied Cyber Threat Intelligence Bootcamp',
    description: 'Three-day hands-on training designed to equip cybersecurity professionals with skills to collect, analyze, automate, and operationalize Cyber Threat Intelligence (CTI). Learn CTI frameworks, adversary tactics, OSINT techniques, automation, malware and darknet intelligence.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 15-17, 2026',
    time: '9:00 AM - 5:30 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Darshit Ashara',
        bio: 'Principal Security Researcher at Zscaler with 14+ years of experience in monitoring cybercrime discussion places and setting up Threat Intelligence functions. Previously Head of Threat Research at CloudSEK and Threat Intelligence Researcher at Intel471.',
        photo: '/images/trainers/DarshitAshara.png',
        designation: 'Principal Security Researcher',
        company: 'Zscaler',
      },
      {
        name: 'Rahul Binjve',
        bio: 'Currently leads the Cyber Threat Intelligence (CTI) Engineering team at Fortinet with 10+ years of experience in aggregating and contextualizing threats. Presented at Black Hat, Nullcon, PHDays, c0c0n, and contributed to open-source security projects like SHIVA spampot and Detux Linux sandbox.',
        photo: '/images/trainers/RahulBinjve.png',
        designation: 'CTI Engineering Team Lead',
        company: 'Fortinet',
      },
    ],
    level: 'Intermediate',
    venue: 'Physical',
    price: '₹37,000',
    tags: ['Threat Intelligence', 'OSINT', 'CTI', 'Automation', 'Malware Analysis', 'Python'],
    featured: true,
    popular: true,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=93614',
  },
  {
    id: 22,
    title: 'Securing the AI-Native Enterprise: A Leadership Playbook for Agents, RAG, MCP & Autonomous Risk',
    description: 'Executive-focused one-day training for security leaders to understand AI-native threat landscapes, secure agentic systems, and enable AI adoption without becoming the bottleneck. Learn to evaluate AI use cases, apply security frameworks (OWASP, SAIF, CoSAI, AARM), and implement behavior-based security controls for autonomous systems.',
    eventName: 'Byt3con June 2026',
    date: 'Jun 18, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '1 Day',
    instructors: [
      {
        name: 'Avkash Kathiriya',
        bio: 'Avkash Kathiriya is a cybersecurity leader and AI security practitioner with 15+ years of experience across Cyber Defense, Threat Intelligence, Security Orchestration, and AI Security. He currently serves as Senior Vice President of Research at a US-based cybersecurity product company, leading AI-driven security research and innovation.\n\nHe has hands-on experience building production-grade AI and agentic security applications, with expertise in AI security copilots, autonomous security workflows, AI agent architectures, runtime enforcement, threat modeling for AI-native systems, and LLM security testing. His work spans both "AI for Security" and "Security for AI," including prompt injection risks, AI governance, secure autonomous execution, and enterprise AI risk management.\n\nAvkash is also a recognized speaker at cybersecurity conferences in India and internationally and serves as a visiting faculty member at IIIT Sri City.',
        photo: '/images/trainers/AvkashKathiriya.jpeg',
        designation: 'Co-founder',
        company: 'Fencio',
      },
      {
        name: 'Aashish Bharadwaj',
        bio: 'Co-founder of Fencio, an AI agent security platform focused on helping enterprises secure their agentic AI systems. Brings deep expertise in building and securing large-scale distributed infrastructure. Previously at Nutanix, where he established the security function and worked extensively on security systems, backend architecture, and vulnerability management. Specialized in AI agent security, application security, and secure system architecture.',
        photo: '/images/trainers/Aashish_Bharadwaj.jpeg',
        designation: 'Co-founder',
        company: 'Fencio',
      },
    ],
    level: 'Executive',
    venue: 'Online Virtual',
    price: '₹16,000',
    tags: ['AI Security', 'Security Leadership', 'Governance', 'Risk Management', 'CISO', 'Agentic Systems'],
    featured: true,
    popular: false,
    status: 'archived',
    buyUrl: 'https://konfhub.com/checkout/byt3con-security-training-bengaluru-2026?ticketId=93615',
  },
  {
    id: 23,
    title: 'Practical Offensive Recon for Modern Attack Surfaces',
    description: 'Hands-on training on attacker-grade reconnaissance against modern organizations : discovering internet-facing assets, AI exposures, cloud/API/SaaS attack surfaces, and building realistic attack paths using real-world targets and enterprise-scale datasets.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Shubham Mittal',
        bio: 'Shubham Mittal is Director & Head of Research at RedHuntLabs and an active Information Security researcher with 8+ years of experience in offensive/defensive security. He has interests in Perimeter Security, Web AppSec, and Product Engineering. He is a review board member at BlackHat Asia, RootConf, and Pycon India (Information Security Track). He has spoken/trained/presented at multiple conferences including Blackhat, DEFCON, NullCon, c0c0n, RootConf, and IETF. He is the author of OSINT Framework - DataSploit (listed in Top Ten Security Tools of 2016) and is the core organizer of ReconVillage which runs at DEFCON and other security conferences. He works from the command line, uses vi, and loves beer.',
        knownFor: 'Creator of DataSploit (Top 10 Security Tool, 2016) · Co-organizes ReconVillage at DEFCON',
        photo: '/images/trainers/ShubhamMittal.jpeg',
        designation: 'Director & Head of Research',
        company: 'RedHuntLabs',
      },
      {
        name: 'Kumar Ashwin',
        bio: 'Kumar Ashwin is a security researcher and engineer at RedHunt Labs with a focus on offensive security, reconnaissance, cloud security, software supply chain security, and emerging attack surfaces introduced by AI systems. His work focuses on understanding how modern organizations become exposed beyond their traditional web perimeter - through cloud infrastructure, source-code platforms, APIs, SaaS applications, CI/CD systems, third-party services, leaked data, and AI infrastructure. Ashwin has delivered technical trainings, talks, and research at security conferences including Black Hat, DEF CON, Nullcon, c0c0n, x33fcon and other security communities. His work combines large-scale security research with practical offensive techniques and tooling, with an emphasis on techniques that can be applied during real penetration tests, red-team engagements, attack-surface assessments, and security research.',
        photo: '/images/trainers/KumarAshwin.jpeg',
        designation: 'Security Researcher & Engineer',
        company: 'RedHuntLabs',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    price: '₹32,999',
    tags: ['Reconnaissance', 'OSINT', 'AI Security', 'Attack Surface Management'],
    featured: true,
    popular: true,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-practical-offensive-recon.pdf',
  },
  {
    id: 24,
    title: 'Securing the AI-Native Enterprise: A Leadership Playbook for Agents, RAG, MCP & Autonomous Risk',
    description: 'Executive-focused one-day training for security leaders to understand AI-native threat landscapes, secure agentic systems, and enable AI adoption without becoming the bottleneck. Learn to evaluate AI use cases, apply security frameworks (OWASP, SAIF, CoSAI, AARM), and implement behavior-based security controls for autonomous systems.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '1 Day',
    instructors: [
      {
        name: 'Avkash Kathiriya',
        bio: 'Avkash Kathiriya is a cybersecurity leader and AI security practitioner with 15+ years of experience across Cyber Defense, Threat Intelligence, Security Orchestration, and AI Security. He currently serves as Senior Vice President of Research at a US-based cybersecurity product company, leading AI-driven security research and innovation.\n\nHe has hands-on experience building production-grade AI and agentic security applications, with expertise in AI security copilots, autonomous security workflows, AI agent architectures, runtime enforcement, threat modeling for AI-native systems, and LLM security testing. His work spans both "AI for Security" and "Security for AI," including prompt injection risks, AI governance, secure autonomous execution, and enterprise AI risk management.\n\nAvkash is also a recognized speaker at cybersecurity conferences in India and internationally and serves as a visiting faculty member at IIIT Sri City.',
        knownFor: 'Builds production-grade AI security copilots and agent architectures',
        photo: '/images/trainers/AvkashKathiriya.jpeg',
        designation: 'Co-founder',
        company: 'Fencio',
      },
      {
        name: 'Aashish Bharadwaj',
        bio: 'Co-founder of Fencio, an AI agent security platform focused on helping enterprises secure their agentic AI systems. Brings deep expertise in building and securing large-scale distributed infrastructure. Previously at Nutanix, where he established the security function and worked extensively on security systems, backend architecture, and vulnerability management. Specialized in AI agent security, application security, and secure system architecture.',
        knownFor: 'Built and led large-scale distributed infrastructure security programs',
        photo: '/images/trainers/Aashish_Bharadwaj.jpeg',
        designation: 'Co-founder',
        company: 'Fencio',
      },
    ],
    level: 'Executive',
    venue: 'Online Virtual',
    price: '₹14,999',
    tags: ['AI Security', 'Security Leadership', 'Governance', 'Risk Management', 'CISO', 'Agentic Systems'],
    featured: true,
    popular: false,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-securing-ai-native-enterprise.pdf',
  },
  {
    id: 25,
    title: 'AI-Native Security Engineering: Building Agents That Hack, Hunt & Defend',
    description: 'Hands-on training to build AI agents that hunt real vulnerabilities across applications, infrastructure, supply chains, and logs, confirm exploitability, write the fix, open the PR, and verify it works : chained into observable, production-ready multi-agent pipelines.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Chandrapal Badshah',
        bio: 'Chandrapal Badshah is a Senior Security Engineer with 8+ years of experience building practical cloud and product security across fast-moving startups. He has been working at the intersection of AI and security, from contributing to Prowler\'s Lighthouse feature, which brought AI-powered analysis to one of the most widely adopted open-source cloud security tools, to writing critically about the space in pieces like "So-Called AI-Powered Cloud Security" and "AI Is the Best Thing to Happen to Security." He has led security programs that reduced critical vulnerabilities by 100%, implemented Secure-by-Design principles at scale, and holds CKA, CKAD, CKS, and other cloud platform certifications. He has delivered hands-on trainings at Nullcon, Vulncon, x33fcon, BSides Delhi, BSides Goa, and many others, all known for their no-slideware, immediately deployable approach. He shares technical research at badshah.io.',
        knownFor: 'Contributed AI-powered analysis to a widely-used open-source cloud security tool',
        photo: '/images/trainers/ChandrapalBadshah.jpeg',
        designation: 'Senior Security Engineer',
      },
      {
        name: 'Manoj Deshmukh',
        bio: 'Manoj Deshmukh is a Security Engineer with 6+ years of experience helping organizations secure cloud-native applications, Kubernetes platforms, and modern software delivery pipelines. He has worked across telecom, SaaS, and enterprise environments, performing security assessments across applications, APIs, cloud infrastructure, and containerized workloads. Currently a Security Engineer at JumpCloud, Manoj helps strengthen the security of cloud and Kubernetes environments by driving security reviews, risk reduction initiatives, and secure engineering practices. He has delivered hands-on workshops and talks at Nullcon Goa, KCD Bangalore, OWASP Bangalore, and Null Community, focusing on Kubernetes security, cloud-native attack paths, runtime security, and practical defensive techniques. He is the creator of 0labs.cc and shares security research and hands-on learning resources through deshmukh.cc.',
        knownFor: 'Creator of 0labs.cc, a hands-on Kubernetes security learning platform',
        photo: '/images/trainers/ManojDeshmukh.jpeg',
        designation: 'Security Engineer',
        company: 'JumpCloud',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    price: '₹32,999',
    tags: ['AI Security', 'Automation', 'Security Engineering'],
    featured: true,
    popular: true,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-ai-native-security-engineering.pdf',
  },
  {
    id: 26,
    title: 'AI-Augmented Kubernetes Security: Attack, Detect, and Defend',
    description: 'Practical training on how attackers target Kubernetes environments and how defenders can use modern security tools and AI assistance to respond faster. Learn to find and exploit common Kubernetes misconfigurations, use AI to support reconnaissance and identify attack paths, abuse exposed services and weak RBAC, understand attacks against container images and GitOps pipelines, investigate suspicious activity using audit logs and Falco, use K8sGPT to explain cluster problems, and apply Pod Security Standards and policy-as-code.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Madhu Akula',
        bio: 'Madhu Akula is a pragmatic security leader and creator of Kubernetes Goat, an intentionally vulnerable by-design Kubernetes Cluster to learn and practice Kubernetes Security. Also published author and cloud-native security architect with extensive experience. Also, he is an active member of the international security, DevOps, and cloud-native communities (null, DevSecOps, AllDayDevOps, AWS, CNCF, USENIX, OWASP, etc). Holds industry certifications like OSCP (Offensive Security Certified Professional), CKA (Certified Kubernetes Administrator), CKS (Certified Kubernetes Security Specialist), etc. Madhu frequently speaks and runs training sessions at security events and conferences around the world including DEFCON (24, 26, 27, 28, 29, 30, 31, 32 & 33), BlackHat USA, EU, Asia (2018, 19, 21, 22, 23, 24 & 25), USENIX LISA (2018, 19 & 21), SANS Cloud Security Summit 2021 & 2022, O\'Reilly Velocity EU, GitHub Satellite, Appsec EU (2018, 19 & 22), All Day DevOps (2016, 17, 18, 19, 20, 21, 22, 23 & 24), DevSecCon (London, Singapore, Boston), DevOpsDays India, c0c0n(2017, 18 & 20), Nullcon (2018, 19, 21 & 22), SACON, WeAreDevelopers, null and multiple others. His research has identified vulnerabilities in over 200+ companies and organisations including; Google, Microsoft, LinkedIn, eBay, AT&T, WordPress, NTOP Adobe, etc, and is credited with multiple CVEs, Acknowledgements, and rewards. He is co-author of Security Automation with Ansible2 (ISBN-13: 978-1788394512), which is listed as a technical resource by Red Hat Ansible. He is the technical reviewer for Learn Kubernetes Security, and Practical Ansible2 books by Packt Pub. Also won 1st prize for building an Infrastructure Security Monitoring solution at InMobi flagship hackathon among 100+ engineering teams. In addition to his technical expertise, Madhu advises startups on building exceptional products and communities, helping them add significant value along the way.',
        knownFor: 'Creator of Kubernetes Goat · 9× DEFCON, 6× Black Hat speaker',
        photo: '/images/trainers/MadhuAkula.jpeg',
        designation: 'Pragmatic Security Leader',
      },
      {
        name: 'Shivankar Madaan',
        bio: 'Experienced Senior Security Engineer with a demonstrated history of working in the information technology and services industry. Skilled in Cloud Security, Web Security, Mobile Security, Python, Network Security, and Amazon Web Services (AWS). Strong information technology professional with a Bachelor of Engineering - BE focused in Computer Science from PES College of Engineering.\n\nShivankar is currently a Staff Security Engineer at Bitvavo (Amsterdam, Netherlands), and previously founded SupplySafe. Earlier in his career, he worked as a Security Engineer at Kraken Digital Asset Exchange, a Senior Security Engineer at AutoScout24 (Munich, Germany), and a Senior Security Engineer at Navi.',
        knownFor: 'Staff Security Engineer at Bitvavo · Founder, SupplySafe',
        photo: '/images/trainers/ShivankarMadaan.jpeg',
        designation: 'Staff Security Engineer',
        company: 'Bitvavo',
      },
    ],
    level: 'Intermediate',
    venue: 'Online Virtual',
    price: '₹32,999',
    tags: ['Kubernetes Security', 'AI', 'Cloud Security'],
    featured: true,
    popular: true,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-ai-augmented-kubernetes-security.pdf',
  },
  {
    id: 27,
    title: 'FlipScript: Turning AI from Attack Vector into Defense Multiplier',
    description: 'A hands-on three-day program that takes participants from manual threat modeling to a fully AI-native security practice. Learn to build autonomous threat models with DREAD, attack trees, ASVS, and DFDs using ThreatShield; stand up Secura for AI-driven detection and automated incident response; and create a personalized 30-day transformation roadmap. By Day 3, you will have built an automated pipeline, wired a CI/CD deployment gate, configured autonomous incident-response agents, and designed AI-native security processes.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Satyam Nagpal',
        bio: 'Satyam Nagpal is a Lead Security Engineer at CRED with extensive experience in application security, API security, mobile security, threat modeling, and DevSecOps. He is passionate about building security automation that helps engineering teams identify and remediate risks early in the software development lifecycle. His work focuses on applying artificial intelligence to security engineering, with a particular emphasis on automating threat modeling, secure design reviews, and vulnerability management. He is the creator of ThreatShield, an AI-powered platform that transforms engineering artifacts into comprehensive threat models, attack trees, DREAD assessments, and actionable security recommendations. Satyam is an active contributor to the global cybersecurity community and has presented security tools and research at Black Hat Asia, Black Hat USA, and Black Hat Europe. He is committed to making secure-by-design practices more accessible, scalable, and practical through AI and automation.',
        knownFor: 'Creator of ThreatShield, an AI-powered threat modeling platform',
        photo: '/images/trainers/SatyamNagpal.jpeg',
        designation: 'Lead Security Engineer',
        company: 'CRED',
      },
    ],
    level: 'Intermediate',
    venue: 'Online Virtual',
    price: '₹32,999',
    tags: ['AI Security', 'Threat Modeling', 'DevSecOps'],
    featured: false,
    popular: false,
    status: 'cancelled',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
  },
  {
    id: 28,
    title: 'Adversarial DevSecOps: From Code Commit to Cloud Audit',
    description: 'A 1-day intensive, hands-on workshop designed to teach engineers how to build, break, and defend modern software supply chains. Moving beyond basic compliance, this course forces students to think like attackers while building robust, automated defensive pipelines. Learn to weaponize AI for static code analysis, deploy autonomous AI agents for dynamic attacks, master git history manipulation for secrets remediation, and build a custom telemetry and ChatOps observer to monitor pipeline drift and privileged AWS actions in real-time.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '1 Day',
    instructors: [
      {
        name: 'Jovin Lobo',
        bio: 'Seasoned information security leader with over 12 years of experience specializing in application, network, and cloud security assessments. Currently leads the DevSecOps practice at a major fintech product company, where he collaborates with engineering teams to automate security controls and helps achieve PCI-DSS and ISO27001 compliance. Deeply passionate about the intersection of AppSec, DevSecOps, and Artificial Intelligence, actively pioneering the integration of LLMs to automate complex security guardrails. Driven by the philosophy that the future of security engineering should run on "auto-pilot." Frequent speaker and trainer at BSides Dublin, nullcon, COCON, and GNUnify.',
        photo: '/images/trainers/JovinLobo.jpeg',
        designation: 'DevSecOps Lead',
        company: 'Verto',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    price: '₹14,999',
    tags: ['DevSecOps', 'CI/CD', 'Cloud Security'],
    featured: true,
    popular: true,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-adversarial-devsecops.pdf',
  },
  {
    id: 29,
    title: 'Smart Contract Security from Basics to Real-World Exploits',
    description: 'A 3-day hands-on training covering blockchain fundamentals, smart contract security in Solidity, and real-world exploit techniques. From consensus mechanisms and EVM internals through vulnerability classes like reentrancy and oracle manipulation, to DeFi protocol attacks and MEV exploitation. Students deploy vulnerable contracts, reproduce famous exploits, and practice defensive remediation using Slither and Mythril. Every concept is paired with a lab:understand the vulnerability, exploit it, then fix it.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '3 Days',
    instructors: [
      {
        name: 'Anto Joseph',
        bio: 'Anto is a Principal Security Engineer at Eigenlabs working on distributed systems, protocol security, and Applied AI. He spends a good deal of energy pushing secure design practices across protocols during his security role at Coinbase. Before that his security career ran through Tinder, Intel, Citrix, and EY. He\'s a regular trainer and speaker at the major venues like Black Hat USA, DEF CON, BruCON, Hack In Paris, HITB Amsterdam, Hack.lu, Hacktivity, PHDays, X33fCon, Nullcon, c0c0n and contributes to open-source security tooling.',
        knownFor: 'Speaker at Black Hat, DEF CON, BruCON & more · Contributes to open-source security tooling',
        photo: '/images/trainers/AntoJoseph.png',
        designation: 'Principal Security Engineer',
        company: 'Eigenlabs',
      },
    ],
    level: 'Intermediate',
    venue: 'Online Virtual',
    price: '₹32,999',
    tags: ['Smart Contracts', 'Web3 Security', 'DeFi'],
    featured: true,
    popular: true,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-smart-contract-security.pdf',
  },
  {
    id: 30,
    title: 'Build Your Own AI-Augmented CSPM Using Open Source and Cloud Native Services',
    description: 'Hands-on training to build a cloud-agnostic CSPM from open-source components spanning AWS, Azure, and GCP : asset inventory, attack-path graphing, policy-as-code, compliance reporting, continuous/event-driven detection, guarded remediation, and an AI layer for triage and natural-language querying.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-18, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '2 Days',
    instructors: [
      {
        name: 'Anant Shrivastava',
        bio: 'Founder of Cyfinoid Research with expertise in security (offense and defense), development, and operations. Trainer and speaker at Black Hat USA/Asia/EU, Nullcon, c0c0n, and other renowned conferences. Leads open-source projects including Tamer Platform and CodeVigilant. Active contributor to null community, Garage4Hackers, and OWASP.',
        knownFor: 'Speaker at Black Hat USA/Asia/EU & Nullcon · Creator of Tamer Platform & CodeVigilant',
        photo: '/images/trainers/AnantShrivastava.webp',
        designation: 'Founder',
        company: 'Cyfinoid',
      },
      {
        name: 'Riyaz Walikar',
        bio: 'Riyaz Walikar is a seasoned security researcher, evangelist and offensive security expert with a wealth of experience across industry verticals and technologies. Riyaz has over 15 years of hands on offensive security experience focussing on Web, API, Mobile, Thick Clients, Systems, Internet facing and unreachable infra, Wireless, Cloud, Container, Kubernetes and more recently AI Agentic and MCP security.\n\nProfessionally, Riyaz has run pentesting and research teams at Microland, PwC, Citrix, Appsecco and Kloudle in the past. He now does full time research and consulting on his own while continuing to mentor and teach at various events and conferences.\n\nWhen he isn\'t breaking things and looking under the hood of systems, Riyaz loves to stargaze, do photograhy, travel, google for easy weight loss solutions and crack really bad jokes to gain more followers.',
        photo: '/images/trainers/RiyazWalikar.jpeg',
      },
    ],
    level: 'Intermediate',
    venue: 'Online Virtual',
    price: '₹23,999',
    tags: ['Cloud Security', 'CSPM', 'Multi-Cloud', 'AI Security', 'DevSecOps'],
    featured: true,
    popular: true,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-ai-augmented-cspm.pdf',
  },
  {
    id: 31,
    title: 'Threat Hunting Using Memory Forensics',
    description: 'Intensive hands-on training in memory forensics for threat hunting, malware detection, and incident response — covering Volatility, process/rootkit investigation, and code-injection analysis.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-18, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '2 Days',
    instructors: [
      {
        name: 'Monnappa K A',
        bio: 'Principal threat researcher with 17+ years in incident response and investigation. Previously a threat hunter at Microsoft and Cisco. Author of the best-selling book "Learning Malware Analysis," review board member for Black Hat Asia/USA/Europe, creator of the Limon Linux sandbox, and winner of the 2016 Volatility plugin contest. Co-founder of Cysinfo.',
        designation: 'Principal Threat Researcher',
        company: 'Cysinfo',
        photo: '/images/trainers/MonnappaKA.png',
      },
      {
        name: 'Sajan Shetty',
        bio: 'Cyber security enthusiast and active member of Cysinfo. Has trained at Black Hat, with a focus on malware analysis, memory forensics, and applying machine learning to security problems.',
        designation: 'Security Researcher',
        company: 'Cysinfo',
        photo: '/images/trainers/SajanShetty.jpeg',
      },
    ],
    level: 'All Levels',
    venue: 'Online Virtual',
    price: '₹23,999',
    tags: ['Memory Forensics', 'Malware Analysis', 'Rootkits', 'Threat Hunting'],
    featured: false,
    popular: false,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-threat-hunting-memory-forensics.pdf',
  },
  {
    id: 32,
    title: 'AI Governance & Strategic Risk Management',
    description: 'Executive-focused one-day training bridging AI innovation and executive accountability : a deep dive into building an AI Management System (AIMS) using ISO/IEC 42001 and NIST AI RMF 1.0 to manage the probabilistic risks of AI while ensuring compliance with global and Indian regulatory mandates (EU AI Act, RBI, DPDP).',
    eventName: 'Byt3con September 2026',
    date: 'Sep 19, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '1 Day',
    instructors: [
      {
        name: 'Chaitanya Kamble',
        bio: 'Chaitanya is a Governance, Risk, and Information Security leader with over 17 years of experience supporting banks, payment institutions, fintechs, and regulated entities in strengthening security, compliance, and regulatory readiness. His expertise spans RBI and NPCI regulatory expectations, payment security standards, data protection mandates, and operational resilience frameworks. He brings a strong technical foundation in security architecture, application and network security testing, and risk management, enabling him to bridge regulatory requirements with practical system implementation. Chaitanya is recognized for helping organizations move beyond audit-driven compliance toward structured, sustainable, and regulator-aligned security operating models. He has delivered training and advisory engagements for financial institutions across India and international markets, focusing on practical control implementation, risk-based compliance, and defensible regulatory positioning.',
        photo: '/images/trainers/ChaitanyaKamble.jpeg',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    price: '₹14,999',
    tags: ['AI Governance', 'Risk Management', 'Compliance', 'ISO 42001', 'NIST AI RMF'],
    featured: false,
    popular: false,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-ai-governance-risk-management.pdf',
  },
  {
    id: 33,
    title: 'Extension Impossible: Weaponizing, Hunting and Containing Browser Extensions',
    description: 'Advanced, lab-first training on the browser extension attack surface — participants build a malicious extension on Day 1, then triage, reverse-engineer, and contain a classmate\'s build on Day 2, closing with enterprise policy, threat hunting, and incident response.',
    eventName: 'Byt3con September 2026',
    date: 'Sep 17-18, 2026',
    time: '9:00 AM - 5:00 PM IST',
    duration: '2 Days',
    instructors: [
      {
        name: 'Ishan Girdhar',
        bio: 'Ishan Girdhar has spent fifteen years securing high-stakes global financial platforms, leading product and information security at Grab, eBay, PayPal, Funding Societies, and Assembly Payments, and delivering security consulting to banks, insurers, and government institutions through Accenture\'s APAC financial services practice. He is the founder of Alpha CISO and the creator of Extension Auditor, a platform that continuously analyses the Chrome Web Store — work that grew directly out of the Honey/PayPal affiliate-manipulation incident, where traditional endpoint security could see nothing at all. His research corpus spans over a million analysed extension versions, and this course is built on what that corpus revealed.',
        photo: '/images/trainers/IshanGirdhar.jpeg',
        designation: 'Founder',
        company: 'Alpha CISO',
      },
    ],
    level: 'Advanced',
    venue: 'Online Virtual',
    price: '₹23,999',
    tags: ['Browser Security', 'Extension Security', 'Red Team', 'Detection Engineering', 'Threat Hunting'],
    featured: true,
    popular: true,
    status: 'upcoming',
    buyUrl: 'https://konfhub.com/checkout/byt3con-online-training-september-2026',
    businessCasePdf: '/documents/trainings/byt3con-sept2026-extension-impossible.pdf',
  },
];
